import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import breakpoints from "../../../styles/breakpoints";
import { fonts } from "../../../styles/variables";

export const StyledProductCollectionGalleryHolder = styled.div`
  margin-bottom: 40px;
  ${breakpoints.smDown} {
    margin-bottom: 35px;
  }
  ${breakpoints.iphone5} {
    width: 320px;
  }
  ${breakpoints.iphone678} {
    width: 360px;
  }
  ${breakpoints.iphone678plus} {
    width: 400px;
  }
  ${breakpoints.xsDown} {
    margin-bottom: 15px;
  }
`;

export const StyledTitle = styled.h2`
  font-family: ${fonts.fontInterstateBlackCompressed};
  font-size: 50px;
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  ${breakpoints.smUp} {
    padding-right: 0px;
  }
  ${breakpoints.smDown} {
    font-size: 25px;
    padding-right: 0;
  }
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${breakpoints.smDown} {
    margin-bottom: 20px;
  }
`;

export const ArrowNavigatorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const HorizontalContainer = styled.div<{ showProductsOnSingleRow: boolean }>`
  display: flex;
  ${(props) =>
    props.showProductsOnSingleRow
      ? css`
          overflow: auto;
          flex-wrap: nowrap;
          margin: 40px 0 0 0;
          align-items: center;
          ::-webkit-scrollbar,
          ::-webkit-scrollbar-thumb,
          ::-webkit-scrollbar-track {
            display: none;
          }
        `
      : css`
          flex-wrap: wrap;
          margin: 40px -8px 0 -8px;
        `}

  ${breakpoints.smDown} {
    margin-top: 16px;
    width: 100%;
  }
`;

export const TopSeeAllText = styled(Link)`
  text-transform: uppercase;
  font-size: 14px;
  font-family: ${fonts.fontInterstateUltraBlack};
  vertical-align: middle;
  margin-right: 15px;
  max-width: 100px;
  ${breakpoints.smDown} {
    padding-right: 0;
    margin-right: 0;
  }
`;

export const SeeAllText = styled(Link)`
  text-transform: uppercase;
  font-size: 12px;
  font-family: ${fonts.fontBauMedium};
  text-decoration: underline;
  width: 100px;
  margin-right: 15px;
  max-width: 50px;
  margin-left: 10px;
`;
